import * as React from 'react';
import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DropdownOption, CustomSetting } from 'types/types';

const useStyles = makeStyles((theme) => ({
  textField: {
    width: '45%',
    whiteSpace: 'pre-line',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(2)
  }
}));

type DropdownSectionProps = {
  inputSetting: CustomSetting;
  initialSelectValue: any;
  setSave: React.Dispatch<
    React.SetStateAction<Record<string, string | boolean>>
  >;
};

export const DropdownSection: React.FC<DropdownSectionProps> = ({
  inputSetting,
  initialSelectValue,
  setSave
}: DropdownSectionProps) => {
  if (initialSelectValue === undefined) {
    const options = inputSetting?.dropdownOptions as DropdownOption[];
    initialSelectValue = Object.values(options[0])[0];
  }
  const matchObject = inputSetting?.dropdownOptions?.reduce((acc, obj) => {
    const [key, value] = Object.entries(obj)[0];
    if (value === initialSelectValue) {
      acc = { [key]: value };
    }
    return acc;
  }, {} as { [key: string]: any });

  const [input, setInput] = React.useState(JSON.stringify(matchObject));
  const classes = useStyles();

  const handleChange = React.useCallback((event: any) => {
    setInput(event.target.value);
  }, []);

  React.useEffect(() => {
    if (inputSetting?.id === undefined) return;
    const id = inputSetting.id;
    const value = JSON.parse(input) as DropdownOption;
    setSave((prev) => ({ ...prev, [id]: Object.values(value)[0] }));
  }, [setSave, input, inputSetting?.id]);

  return (
    <FormControl
      className={classes.textField}
      data-testid="render-dropdown-components"
    >
      <Select
        id="select-dropdownOptions"
        size="small"
        value={input}
        onChange={handleChange}
        data-testid="check-select-options"
        role="combobox"
      >
        {inputSetting?.dropdownOptions &&
          inputSetting.dropdownOptions.map((dropdownOption, index) => (
            <MenuItem
              key={index}
              value={JSON.stringify(dropdownOption) as string}
            >
              {Object.keys(dropdownOption)}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText data-testid="check-helperText">
        {inputSetting?.helperTextValue}
      </FormHelperText>
    </FormControl>
  );
};
